(()=>{
  const checkQuantityIncrease = () => {
    const quantityIncreases = document.querySelectorAll(
      "span.rebuy-cart__flyout-item-quantity-widget-label + button.rebuy-cart__flyout-item-quantity-widget-button"
    );
    quantityIncreases.forEach((quantityIncrease) => {
      quantityIncrease.addEventListener("click", () => {
        document.getElementById("cart-icon-bubble").click();
      });
    });
    if (quantityIncreases.length > 0) clearInterval(intervalQuantity);
  };

  const checkAndAddEventListeners = () => {
    const Atcs = document.querySelectorAll(
      ".rebuy-product-actions .rebuy-button"
    );
    if (Atcs.length > 0) {
      Atcs.forEach((Atc) => {
        Atc.addEventListener("click", () => {
          document.getElementById("cart-icon-bubble").click();
        });
      });
      clearInterval(intervalAtc);
    }
  };

  const intervalQuantity = setInterval(checkQuantityIncrease, 500);
  const intervalAtc = setInterval(checkAndAddEventListeners, 500);
})();
